import styled from "styled-components";

export const CustomTabTemplate = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CustomTabBox = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.colors.black8};
  justify-content: space-between;
`;
